<template>
  <footer
    class="flex justify-between p-4 bg-th-fill-light border-t border-th-border-lighter"
  >
    <el-pagination
      :page-size="pageSize"
      :current-page="currentPage"
      :background="false"
      layout="sizes, slot"
      :total="total"
      size="default"
      @update:page-size="sizeChanged"
      @update:current-page="currentPageChanged"
    >
      <template #default>
        <span class="text-sm text-th-text-regular ml-4">
          {{ paginationRangeText }}
        </span>
      </template>
    </el-pagination>

    <el-pagination
      ref="pagination"
      :page-size="pageSize"
      :current-page="currentPage"
      :background="false"
      layout="prev, jumper, slot, next"
      :total="total"
      :next-icon="ArrowRightIcon"
      :prev-icon="ArrowLeftIcon"
      size="default"
      @update:page-size="sizeChanged"
      @update:current-page="currentPageChanged"
    >
      <template #default>
        <span class="text-sm text-th-text-regular">
          {{ $t('components.th_datatable.pagination.of') }}
          {{ Math.ceil(total / pageSize) }}
        </span>
      </template>
    </el-pagination>
  </footer>
</template>

<script>
import { ArrowLeftIcon, ArrowRightIcon } from '@shared/assets/icons'

// Element UI Pagination wrapper
// https://element.eleme.io/#/en-US/component/pagination#pagination

export default {
  name: 'THPagination',
  props: {
    // Current page number,
    currentPage: {
      type: Number,
      required: true
    },

    // Total item count
    total: {
      type: Number,
      required: true
    },

    // Options of item count per page
    pageSizes: {
      type: Array,
      default: () => [5, 10, 20]
    },

    // Item count of each page
    pageSize: {
      type: Number,
      default: null
    },

    // Layout of the pagination
    layout: {
      type: String,
      default: 'total, sizes, prev, pager, next, jumper'
    }
  },

  emits: ['size-change', 'current-change'],

  data() {
    return {
      ArrowLeftIcon,
      ArrowRightIcon
    }
  },

  computed: {
    paginationRangeText() {
      const start = (this.currentPage - 1) * this.pageSize + 1
      const end = Math.min(this.currentPage * this.pageSize, this.total)
      return `${start}-${end} ${this.$t('components.th_datatable.pagination.of')} ${this.total}`
    },
    computedPageSize() {
      return this.pageSize || this.pageSizes[0]
    }
  },

  methods: {
    sizeChanged(newSize) {
      this.$emit('size-change', newSize)
    },

    currentPageChanged(newPage) {
      this.$emit('current-change', newPage)
    }
  }
}
</script>

<style scoped>
:deep(.el-pagination .btn-next) {
  margin-left: 1rem;
}

:deep(.el-pagination button) {
  background: none;
  color: var(--el-text-color-regular);
}

:deep(.el-pagination button:disabled) {
  background: none;
}

:deep(.el-pagination button .el-icon) {
  font-size: 1.6rem;
}
</style>
